export const HOMEPAGE = "";

//  Rewards Module routing
export const PUBIC_REWARD_LISTING = "rewards/:integratorId/:subId";
export const PUBLIC_LISTING_PAGE = "deals";
export const REWARD_LISTING = "rewards";

export const REWARD_DETAIL_GIFTCARD_PAGE = "rewards/giftcard/:id/:slugId";
export const REWARD_DETAIL_DISCOUNTOFFER_PAGE = "rewards/discount/:id/:slugId";
export const REWARD_DETAIL_EXPERIENCES_PAGE = "rewards/experience/:id/:slugId";
export const REWARD_DETAIL_MEMBERSHIP_PAGE = "rewards/membership/:id/:slugId";
export const REWARD_DETAIL_CASHBACK_PAGE = "rewards/cashback/:id/:slugId";

export const PUBIC_REWARD_DETAIL_PAGE = "rewards/:brandName/:integratorId/:subId/:id";

export const REWARD_SUMMARY_PAGE = "order/:offerType/:id";

// Subscription Module routing
export const SUBSCRIPTION_LISTING = "subscription";
export const ACTIVE_SUBSCRIPTION_DETAILPAGE = "subscription/:id/:slugId/active";
export const INACTIVE_SUBSCRIPTION_DETAILPAGE = "subscription/:id/:slugId/inactive";

// Travel Module routing
export const TRAVEL_MODULE = "travel";
export const TRAVEL_FLIGHT_MODULE = "travel/flight";
export const TRAVEL_BUS_MODULE = "travel/bus";
export const TRAVEL_TRAIN_MODULE = "travel/train";
export const TRAVEL_HOTEL_MODULE = "travel/hotel";

// VIP Module routing
export const VIP_MODULE = "VIP";
export const VIP_DETAIL = "VIP/:id";

// Commerce Module routing
export const COMMERCE_MODULE = "commerce";
export const COMMERCE_DETAIL = "commerce/:id";

// Experience Module routing
export const EXPERIENCE_MODULE = "experience";
export const EXPERIENCE_DETAIL = "experience/:id";

//  User Profile
export const USER_PROFILE_PAGE = "userProfile";

export const ASSIGNED_OFFER_PAGE = "assignedOffer";
export const USER_ORDER_PAGE = "order";
export const USER_REWARD_PAGE = "reward";
export const USER_WISHLIST_PAGE = "wishlist";
export const USER_NOTIFICATON_PAGE = "notification";
export const USER_SUBSCRIPTION_PAGE = "subscription";

export const CONTACT_US_PAGE = "contact-us";

export const POLICY_PAGE = "policy";

export const POLICY_PRIVACY_PAGE = "privacyPolicy";

export const TERMS_PAGE = "termsOfUse";

export const FAQ_PAGE = "faq";

export const DISCLAIMER_PAGE = "disclaimer";

export const REFUND_PAGE = "cookiePolicy";